import type { ReactNode } from 'react';
import { Button } from '@/components/ui/Button';
import { CheckIcon, CopyIcon } from '@/components/icons';
import { useClipboard } from '@/hooks/useClipboard';

export interface SecretRevealProps {
  /** The secret to display */
  value: string;
  /** Explanation shown above the value */
  label: ReactNode;
  /** Accessible name of the copy button */
  copyLabel?: string;
}

/**
 * Shows a one-time secret (e.g. an agent token) with a copy button that
 * falls back to execCommand on plain-HTTP deployments.
 */
export function SecretReveal({ value, label, copyLabel = 'Copy token' }: SecretRevealProps) {
  const { copiedKey, copy } = useClipboard();
  const copied = copiedKey === 'secret';

  return (
    <div className="node-modal-token-section">
      <p className="node-modal-token-label">{label}</p>
      <div className="node-modal-token-wrapper">
        <code className="node-modal-token" data-testid="secret-value">
          {value}
        </code>
        <Button
          variant="secondary"
          size="sm"
          onClick={() => copy(value, 'secret')}
          leftIcon={copied ? <CheckIcon /> : <CopyIcon />}
          aria-label={copyLabel}
        >
          {copied ? 'Copied!' : 'Copy'}
        </Button>
      </div>
    </div>
  );
}
